// Scrapes product links for data-file tags and returns as an array.
// Works with both table view (.productLinks) and card view (.card-header-link)

export default function () {
  // Try both table links and card links
  const tableLinks = $(".productLinks a");
  const cardLinks = $(".card-header-link");
  
  // Use whichever is available
  const links = tableLinks.length > 0 ? tableLinks : cardLinks;
  
  return links
    .map(function (el) {
      return $(this).data("file");
    })
    .toArray()
    .filter(function (file) {
      // Filter out undefined/null values and ensure uniqueness
      return file != null;
    })
    .filter(function (e, i, arr) {
      return arr.indexOf(e) === i;
    });
}
